import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import QuemSomos from "../pages/quem-somos/page";
import Servicos from "../pages/servicos/page";
import Projectos from "../pages/projectos/page";
import Eventos from "../pages/eventos/page";
import Parceiros from "../pages/parceiros/page";
import Contacto from "../pages/contato/page";
import Faq from "../pages/faq/page";
import PoliticaCookies from "../pages/politica-cookies/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/quem-somos",
    element: <QuemSomos />,
  },
  {
    path: "/servicos",
    element: <Servicos />,
  },
  {
    path: "/projectos",
    element: <Projectos />,
  },
  {
    path: "/eventos",
    element: <Eventos />,
  },
  {
    path: "/parceiros",
    element: <Parceiros />,
  },
  {
    path: "/contato",
    element: <Contacto />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/politica-cookies",
    element: <PoliticaCookies />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;